<header id="home-header" fxFlex="100" fxLayout="column">
  <app-top-fixed-bar [mainPage]="true"></app-top-fixed-bar>
  <app-top-header-bar [mainPage]="true"></app-top-header-bar>
  <app-top-nav-bar></app-top-nav-bar>
</header>

<router-outlet></router-outlet>

<app-footer></app-footer>